const Banner = () => (
  <div
    id='banner'
    className='h-[300px] w-full bg-[url("/images/banners/broker-information-banner.svg")] bg-cover bg-center bg-no-repeat'
  />
);

export default Banner;
